module.exports = __webpack_public_path__ + "images/newerp_button1.1792033684119.png";